export default function isExternalUrl(url) {
  return url.match(/^[a-z]+:/i) || url.startsWith('//');
}
